import * as React from 'react'

import {LabelCountry} from "@components";
import { useBuildExternalURL } from "@hooks"


export default function retailerColumn() {
    return {
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, siteID, productID, date }) => {
				const { productURL } = useBuildExternalURL({ siteData: { siteID, productID } })
				return <LabelCountry
					label={value}
					country={country}
					sx={{ fontSize: 11 }}
					url={productURL}
				/>
			}
        }
    }
}